import React from 'react';
import PartnerWithPilotHelper from './PartnerWithPilotHelper';

const TrainingForColleges = () => {
    return (
        <div className="container pb-5" style={{ maxWidth: '800px', marginTop: '75px', paddingTop: '20px' }}>
            <h1 className="mb-4">How PilotHelper Complements and Strengthens Existing College Peer Support Programs</h1>

            <section className="mb-4">
                <p>
                    PilotHelper strengthens existing college peer support programs by training college pilots and the
                    people they already trust in aviation-specific peer support. Since pilots are often more
                    comfortable opening up to trusted friends and classmates within their program, PilotHelper
                    equips the entire community of college pilots with the skills to recognize when a fellow pilot
                    may be struggling and how to respond appropriately. This approach encourages supportive
                    conversations to happen responsibly among peers who already have established trust.
                </p>
            </section>

            <section className="mb-4">
                <p>
                    Many colleges and universities offer general peer support programs that help students navigate
                    academic and personal challenges. PilotHelper complements these initiatives by providing peer
                    support training specifically designed for the aviation environment. College pilots face unique
                    pressures, including demanding flight training schedules, high performance expectations, and the
                    responsibility of preparing for a safety-critical profession. PilotHelper's peer support training
                    helps college pilots better understand these challenges and how to support one another
                    effectively.
                </p>
            </section>

            <section className="mb-4">
                <p>
                    Rather than relying only on a small group of designated peer mentors, PilotHelper trains all
                    college pilots in peer support fundamentals. By expanding peer support skills across the entire
                    aviation program, more pilots are prepared to recognize early signs of stress or difficulty among
                    their classmates and respond with supportive conversation. This broader approach helps
                    strengthen the existing support systems colleges already provide by reaching college pilots who
                    may be hesitant to utilize formal campus support services.
                </p>
            </section>

            <section className="mb-4">
                <p>
                    By combining aviation-specific training with a trust-based approach, PilotHelper helps colleges
                    build stronger aviation communities where college pilots look out for one another. This not only
                    supports student well-being during training, but also helps prepare future pilots for the
                    collaborative and safety-focused culture of the professional aviation industry.
                </p>
            </section>

            <PartnerWithPilotHelper organizationType="college" emailType="institutional" />
        </div>
    );
};

export default TrainingForColleges;
